import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import chartDe from "./locales/de/chart-de.json";
import chartFr from "./locales/fr/chart-fr.json";
import headerDe from "./locales/de/header-de.json";
import headerFr from "./locales/fr/header-fr.json";

i18n.use(initReactI18next).init({
  resources: {
    de: {
      header: headerDe,
      chart: chartDe,
    },
    fr: {
      header: headerFr,
      chart: chartFr,
    },
  },
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
